export { PersistentStorageStrategyFactory } from './factories';
export { localStorage } from './localStorageSingleton';
export { sessionStorage } from './sessionStorageSingleton';
export { storage } from './storageSingleton';
export { cookieStorageStrategy, localStorageStrategy, noOpStrategy, sessionStorageStrategy, } from './strategies';
